import { useEffect, useState } from "react";
import "./styles.css";
import {
  fetchAllTanks,
  fetchAllTanksSensorData,
  SensorDataProps,
  TankDataProps,
} from "../../controller/tankController";
import NavBar from "../../components/NavBar/NavBar";
import Header from "../../components/Header/Header";
import TankDetails from "./tank-details";
import AddTank from "./add-tank";
import { useLocation } from "react-router-dom";
import Footer from "../../components/Footer";

function Tank() {
  const [showMenu, setShowMenu] = useState(false);
  const [showAddTank, setShowAddTank] = useState<boolean>(false);
  const [showTankDetails, setShowTankDetails] = useState<boolean>(false);
  const [selectedTank, setSelectedTank] = useState<number>(0);
  const [allTanks, setAllTanks] = useState<TankDataProps[]>([]);
  const [allTanksSensorData, setAllTanksSensorData] = useState<
    SensorDataProps[]
  >([]);
  const [selectedTankSensorData, setSelectedTankSensorData] =
    useState<SensorDataProps>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const fetchTanksData = async () => {
      setIsLoading(true);
      try {
        const tankResponse = await fetchAllTanks();
        setAllTanks(tankResponse.data || []);
        console.log("Tank data", tankResponse.data);

        const tankSensorDataResponse = await fetchAllTanksSensorData();
        setAllTanksSensorData(tankSensorDataResponse.data || []);
        console.log("Tank sensor data", tankSensorDataResponse.data);
      } catch (err: any) {
        console.error("Error fetching tank data:", err.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTanksData();
  }, []);

  const handleTankSelection = (tankIndex: number) => {
    const selectedTankData = allTanks[tankIndex];
    const tankUniqueId = selectedTankData.tankUniqueId;

    const tankSensorData = allTanksSensorData.filter(
      (sensorData: any) => sensorData._tank === tankUniqueId
    );

    const latestSensorData =
      tankSensorData.length > 0
        ? (tankSensorData[tankSensorData.length - 1] as SensorDataProps)
        : undefined;

    setSelectedTankSensorData(latestSensorData);
    setSelectedTank(tankIndex);
    setShowTankDetails(true);
  };

  // Function to render tank table content based on loading and data state
  const renderTankTableContent = () => {
    if (isLoading) {
      return (
        <center>
          <h2>Loading...</h2>
        </center>
      );
    }

    if (!allTanks || allTanks.length === 0) {
      return (
        <center>
          <h2>No available tank</h2>
        </center>
      );
    }

    return (
      <>
        {allTanks.map((data, index) => (
          <div
            key={index}
            className="bin-table-row"
            onClick={() => handleTankSelection(index)}
          >
            <div id="index">{(index + 1)?.toString().padStart(2, "0")}</div>
            <div id="bin-id">{data.tankUniqueId}</div>
            <div id="bin-date">{data.manufactureDate}</div>
            <div id="bin-size">{data.tankVolume}</div>
          </div>
        ))}
      </>
    );
  };

  return (
    <div className="dashboard-wrapper" id="bin-wrapper">
      <NavBar hideNav={showMenu} />
      <div className="dashboard-content">
        <Header
          title="Tank"
          setShowMenu={() => setShowMenu(!showMenu)}
          showMenu={showMenu}
        />
      </div>
      <div className="dashboard-content" id="user-containn">
        <div id="tank-container"></div>
        <div className="dashboard-container binn-content" id="tank-container">
          <div className="user-bottom">
            <div
              className="userTop-right"
              style={{ display: "flex", justifySelf: "flex-end" }}
            >
              <button
                className="add-bin-btn"
                onClick={() => setShowAddTank(true)}
              >
                <img src="./images/bin/add.svg" alt="+" />
                Add a new tank
              </button>
            </div>
            <div className="bin-table-div">
              <div className="bin-table">
                <h2 className="table-title">Tanks Available</h2>
                <div className="bin-table-header">
                  <div id="bin-num">#</div>
                  <div>Tank ID </div>
                  <div>Manufacture Date</div>
                  <div>Size</div>
                </div>
                <div className="bin-table-content">
                  {renderTankTableContent()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-cont" id="user-footer-cont">
        <Footer />
      </div>
      {showAddTank && (
        <AddTank showAddTank={showAddTank} setShowAddTank={setShowAddTank} />
      )}
      {showTankDetails && allTanks.length > 0 && (
        <TankDetails
          showTankDetails={showTankDetails}
          setShowTankDetails={setShowTankDetails}
          tankSensorDetails={selectedTankSensorData}
          tankSize={allTanks[selectedTank].tankVolume}
          tankId={allTanks[selectedTank].tankUniqueId}
        />
      )}
    </div>
  );
}

export default Tank;
